import { useEffect, useState } from "react"
import { useUsers } from "../../../hooks/usuarios/useUsers"
import { BotonNuevo } from "../../components/buttons/BotonNuevo"
import { Modal } from "../../components/modal/Modal"
import { ContenedorParametros } from "../../components/utils/ContenedorParametros"
import { ContenedorTabla } from "../../components/utils/ContenedorTabla"
import { SearchTable } from "../../components/utils/SearchTable"
import { Tooltip } from "../../components/utils/Tooltip"
import { MultiSelect } from "../../components/forms/MultiSelect"
import { useSpinner } from "../../../hooks/useSpinner"
import { LineaCarga } from "../../components/LineaCarga"


export const UsuariosPlataforma = () => {

    const idTablaUsuarios = "idTablaUsuarios"
    const classNameInput = "text-white h-[30px] rounded caret-white px-2 bg-zinc-900 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
    const [ mostrarPass, setMostrarPass ] = useState(false);
    const [ spinner, mostrarSpinner, ocultarSpinner ] = useSpinner();
    const [ respuesta, setRespuesta ] = useState(false);
    const autocompletarUID = (valor) => {
        editarValorUsuario("uid",valor.toLowerCase().replace(/[^a-z0-9]/g, '').replace(/\s+/g, ''))
    }

    const formatoFecha  = (fechaAntigua) => {
        if(fechaAntigua !== '')
        {
            let partes = fechaAntigua.split(' ');
            let fechaSinZonaHoraria = partes.slice(0, 4).join(' ');
            let fecha = new Date(fechaSinZonaHoraria);

            let dia = fecha.getDate().toString().padStart(2,'0');
            let mes = (fecha.getMonth() + 1).toString().padStart(2,'0');
            let anio = fecha.getFullYear();

            let horas = fecha.getHours().toString().padStart(2, '0');
            let minutos = fecha.getMinutes().toString().padStart(2, '0');
            let segundos = fecha.getSeconds().toString().padStart(2, '0');

            return `${dia}/${mes}/${anio} ${horas}:${minutos}:${segundos}`;
        }
        else{
            return ''
        }
    }
    
    const {
        usuario,
        usuarios,
        listarUsuariosPlataforma,
        obtenerDatosUsuario,
        guardarEditarUsuariosPlataforma,
        editarValorUsuario,
        isOpenModalRegistrar,
        openModalRegistrar,
        closeModalRegistrar,
        roles,
        listarRoles,
        loading
    } = useUsers()

    useEffect(() =>{
        listarUsuariosPlataforma();
        listarRoles();
    },[])

    useEffect(() => {
        if(respuesta){
            listarUsuariosPlataforma();
            setRespuesta(false);
        }
    },[respuesta])

    const guardarUsuario = async () => {
        mostrarSpinner()
        const isValid = await guardarEditarUsuariosPlataforma();
        setRespuesta(isValid);
        ocultarSpinner()
        if(isValid){
            closeModalRegistrar();
            // await listarUsuariosPlataforma();
            return
        }
    } 
    
    const formatoRoles = roles.map(r => (
        {cod: r, nom: r}
    ))

    return(
        <>

            <ContenedorParametros
                titulo="Usuarios"
            >
                <BotonNuevo
                    onClick={async () => {
                        setMostrarPass(false)
                        obtenerDatosUsuario()
                        openModalRegistrar()
                    }}
                >
                </BotonNuevo>
                <SearchTable tablaId={idTablaUsuarios}></SearchTable>
            </ContenedorParametros>
            {
                loading && <LineaCarga/>  
            }
            <div className='mt-7 relative top-0 bottom-0 left-0 right-0 h-[84vh] overflow-y-auto containerScroll'>
                <table id={idTablaUsuarios} className="table">
                    <thead>
                        <tr key={1}>
                            <th className="text-left">N</th>
                            <th className="text-left">NOMBRES</th>
                            <th className="text-left">USUARIO</th>
                            <th className="text-left">ROL</th>
                            <th className="text-left">F.CREACIÓN</th>
                            {/* <th>ESTADO</th> */}
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            usuarios.length > 0 ?
                                usuarios.map((u,i) => (
                                    <>
                                        <tr key={i+1}>
                                            <td className="">{i+1}</td>
                                            <td className="">
                                                {u.givenName + ' ' + u.apellidoPaterno + ' ' + u.apellidoMaterno}
                                            </td>
                                            <td className="">{u.uid}</td>
                                            <td className="w-[350px]">
                                                <div className="w-[345px] overflow-hidden text-ellipsis whitespace-nowrap">
                                                    {u.role}
                                                </div>
                                            </td>
                                            <td>{u.createdDate ? formatoFecha(u.createdDate) :''}</td>
                                            {/* <td className={`text-center`}>
                                                <span
                                                    className={` ${u.CodEstado ? 'bg-green-600' : 'bg-gray-600'} rounded-md px-1`}
                                                >{u.CodEstado ? 'Activo' : 'Inactivo'}</span>
                                            </td> */}
                                            <td className="text-center">
                                                <button
                                                    data-tip="edit"
                                                    data-for="edit"
                                                    className="bg-blue-600 mb-[3px] px-2 rounded-md w-[40px] h-[25px]"
                                                    onClick={async () => {
                                                        await obtenerDatosUsuario(u);
                                                        openModalRegistrar();
                                                    }}
                                                >
                                                    <i className="fa fa-pen"></i>
                                                </button>
                                                <Tooltip id={'edit'}>Editar usuario</Tooltip>
                                            </td>
                                        </tr>
                                    </>
                                ))
                            :
                                <tr key={0}>
                                    <td colSpan={8} className="text-center">No hay información para mostrar...</td>
                                </tr>
                        }
                    </tbody>
                </table>
            </div>
            <Modal
                title={usuario.createdDate === '' ? "Crear usuario" : `Editar [ ${usuario.uid} ]`}
                isOpen={isOpenModalRegistrar}
                closeModal={closeModalRegistrar}
                action={()=> guardarUsuario()}
                spinner={spinner}
                
            >
                {
                    isOpenModalRegistrar &&
                    <div className="lg:w-[350px] lg:p-2 w-[430px] p-3">
                        {
                            usuario.createdDate === '' &&
                            <div className="flex flex-col">
                                <label className="w-full" htmlFor="nombres">Nombres y apellidos</label>
                                <input
                                    id="nombres"
                                    className={`${classNameInput} w-[400px] lg:w-[300px] disabled:cursor-not-allowed`} 
                                    value={usuario.nombreCompleto}
                                    disabled={usuario.createdDate !== '' ? true : false}
                                    onChange={(e) => {
                                        usuario.createdDate === '' && autocompletarUID(e.target.value);
                                        editarValorUsuario("nombreCompleto",e.target.value)
                                    }}
                                />
                            </div>
                        }
                        {
                            usuario.createdDate === '' ?
                            <div className="flex flex-col">
                                <label className="w-full" htmlFor="uid">Usuario</label>
                                <div className="flex gap-2 items-center">
                                    <input
                                        id="uid"
                                        disabled={usuario.createdDate !== '' ? true : false}
                                        className={`${classNameInput} ${usuario.uid.length > 15 ? ' w-[376px] lg:w-[276px] ' : ' w-[400px] lg:w-[300px]'}`}
                                        value={usuario.uid}
                                        onChange={(e) => editarValorUsuario("uid",(e.target.value).toLowerCase().replace(/[^a-z0-9]/g, '').replace(/\s+/g, ''))}
                                        onDrop={(e) => e.preventDefault()}
                                        onPaste={(e)=> e.preventDefault()}
                                    />
                                    {
                                        usuario.uid.length > 15 ?
                                            <>
                                                <i
                                                    className="fa fa-info-circle text-red-600 cursor-pointer"
                                                    data-tip={'warningID'}
                                                    data-for={'warningID'}
                                                ></i>
                                                <Tooltip id={'warningID'}>Excede los 15 caracteres</Tooltip>
                                            </>
                                        : ''
                                    }
                                </div>
                            </div>
                            : ''
                        }
                        <div className="flex flex-col">
                            <label htmlFor="password">Contraseña {usuario.createdDate !== "" && 'nueva' }</label>
                            <div className="flex gap-1 w-[400px] items-center">
                                <input
                                    id="password"
                                    type={mostrarPass ? 'text' : 'password'}
                                    className={`${classNameInput} w-[376px] lg:w-[300px] `}
                                    value={usuario.userPassword}
                                    onChange={(e) => editarValorUsuario("userPassword" ,e.target.value) }
                                />
                                <i
                                    className={`fa ${mostrarPass? ' fa-eye ' : ' fa-eye-slash'} w-[20px] hover:cursor-pointer`}
                                    onClick={() => setMostrarPass(!mostrarPass)}
                                    data-for={"mostrarOcultar"} 
                                    data-tip={"mostrarOcultar"}
                                ></i>
                                <Tooltip id={"mostrarOcultar"}>{mostrarPass ? 'Ocultar contraseña' : 'Mostrar contraseña'}</Tooltip>
                            </div>
                        </div>
                        <div className="flex flex-col">
                            <label>Rol</label>
                            <MultiSelect
                                search={true}
                                data={formatoRoles}
                                setEdit ={editarValorUsuario}
                                keyEdit={'role'}
                                width={'w-[400px] lg:w-[300px] '}
                                defaultValue={usuario.role}
                                isBlocket={false}
                            />
                        </div>
                    </div>
                }
            </Modal>
        </>
    )
}